import React, {Component} from "react";
import { observer } from "mobx-react";
import OrderMenuLeftView from "../main/body/OrderMenuLeftView";
import OrderMenuListView from "../main/body/List/menu/OrderMenuListView";
import OrderMenuDetailView from "../main/body/List/menu/OrderMenuDetailView";
import SoldOutConfirmView from "../main/body/layer/SoldOutConfirmView";
import {fn_menuSoldOutConfirm} from "../../function/FnBodyLayer";
import {fn_currMenuGroupList} from "../../function/FnBodyMenu";
import {fn_commonInitPage, fn_commonLeftInitPage} from "../../function/FnPage";

@observer
class SettingProdSoldoutView extends Component {

    componentWillUnmount() {
        const { rootStore } = this.props;
        fn_currMenuGroupList(rootStore, null)
        fn_commonLeftInitPage(rootStore)
        fn_commonInitPage(rootStore)
    }

    render() {

        const { rootStore } = this.props;
        const menuCode = rootStore.menuStore.getMenuCode;
        const menuData = rootStore.menuStore.getMenuData;
        const groupCode = rootStore.menuStore.getMenuGroupCode;
        const pageLeftInfo = rootStore.pageStore.getLeftPagingInfo;
        if ( (groupCode === null && menuCode === "") && menuData.length > 0)
            fn_currMenuGroupList(rootStore, menuData[(pageLeftInfo.page_no - 1) * 8].tuClsCd)

        function fn_soldOutLayer(e){
            rootStore.menuStore.setMenuSoldOutCode(e.target.id);
            if( e.target.checked ){
                fn_menuSoldOutConfirm(this.props.rootStore,"cancel");
            }else{
                fn_menuSoldOutConfirm(this.props.rootStore,"action");
            }
        }

        return(
            <>
                <div className="article_menu_setting">
                    <OrderMenuLeftView rootStore={rootStore} />
                    {(menuCode === "") ?
                        <OrderMenuListView rootStore={rootStore} />
                        : <OrderMenuDetailView rootStore={rootStore} fn_soldOutLayer={fn_soldOutLayer}/>
                    }
                </div>
                <SoldOutConfirmView rootStore={rootStore} /> {/*메뉴 품절 확인 창 */}
            </>
        )
    }
}

export default SettingProdSoldoutView;